import s from './LoadingIndicator.module.scss';

export const LoadingIndicator = () => (
  <span className={s.loadingIndicator}>loading...</span>
);
